export default [
    {
        path:"citas",
        component: () => import(/* webpackChunkName: "about" */ '../views/app/servicios/Citas.vue')
    },{
        path:"mensualidad",
        component: () => import(/* webpackChunkName: "about" */ '../views/app/servicios/Mensualidades.vue')
    },
]